// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { AccountClass } from './account-class';
import { AccountTemplate } from './account-template';
import { CreditorClaimType } from './creditor-claim-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AccountGroup extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  accountGroupId!: number;
  accountClassId!: number;
  assetClassId?: number;
  createdBy!: string;
  createdDate!: Date;
  creditorClaimTypeId?: number;
  description!: string;
  description3?: string;
  displayOrder!: number;
  personalAssetClassId?: number;
  subGroup!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  accountClass!: AccountClass;
  accountTemplates!: AccountTemplate[];
  accounts!: Account[];
  creditorClaimType!: CreditorClaimType;
}

